module.exports = __webpack_public_path__ + "media/dashboard/assets/images/open-book-a97b640824e73b8ba93a68f6e9c16903.png";